import React from 'react'
import { useCustomTheme } from '../../../context/ThemeContext'

const WaveBackground = () => {
  const { theme } = useCustomTheme()
  return (
    <>
      <div
        className="backdrop"
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: 'auto',
          overflow: 'hidden',
          zIndex: 0,
        }}
      >
        <svg
          id="wave"
          style={{
            width: '100%',
            height: '40%',
            transform: 'rotate(0deg)',
            transition: '0.3s',
          }}
          viewBox="0 0 1440 380"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="sw-gradient-0" x1="0" x2="0" y1="1" y2="0">
              <stop stopColor={theme.palette.secondary.main} offset="0%" />
              <stop stopColor={theme.palette.primary.main} offset="100%" />
            </linearGradient>
          </defs>
          <path
            style={{ transform: 'translate(0, 0px)', opacity: 1 }}
            fill="url(#sw-gradient-0)"
            d="M0,266L80,221.7C160,177,320,89,480,63.3C640,38,800,76,960,114C1120,152,1280,190,1440,221.7C1600,253,1760,279,1920,247C2080,215,2240,127,2400,133C2560,139,2720,241,2880,272.3C3040,304,3200,266,3360,259.7C3520,253,3680,279,3840,291.3C4000,304,4160,304,4320,266C4480,228,4640,152,4800,133C4960,114,5120,152,5280,164.7C5440,177,5600,165,5760,183.7C5920,203,6080,253,6240,247C6400,241,6560,177,6720,171C6880,165,7040,215,7200,196.3C7360,177,7520,89,7680,101.3C7840,114,8000,228,8160,285C8320,342,8480,342,8640,316.7C8800,291,8960,241,9120,196.3C9280,152,9440,114,9600,133C9760,152,9920,228,10080,215.3C10240,203,10400,101,10560,63.3C10720,25,10880,51,11040,101.3C11200,152,11360,228,11440,266L11520,304L11520,380L11440,380C11360,380,11200,380,11040,380C10880,380,10720,380,10560,380C10400,380,10240,380,10080,380C9920,380,9760,380,9600,380C9440,380,9280,380,9120,380C8960,380,8800,380,8640,380C8480,380,8320,380,8160,380C8000,380,7840,380,7680,380C7520,380,7360,380,7200,380C7040,380,6880,380,6720,380C6560,380,6400,380,6240,380C6080,380,5920,380,5760,380C5600,380,5440,380,5280,380C5120,380,4960,380,4800,380C4640,380,4480,380,4320,380C4160,380,4000,380,3840,380C3680,380,3520,380,3360,380C3200,380,3040,380,2880,380C2720,380,2560,380,2400,380C2240,380,2080,380,1920,380C1760,380,1600,380,1440,380C1280,380,1120,380,960,380C800,380,640,380,480,380C320,380,160,380,80,380L0,380Z"
          ></path>
        </svg>
      </div>

      <div
        className="backdrop"
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: 'auto',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ width: '80%' }}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100% 200" width="100%" height="200">
            <g transform="translate(100, 50)">
              <circle cx="0" cy="0" r="1.5" fill="white" />
              <path
                d="M0,-5 L0,5 M-5,0 L5,0"
                stroke="white"
                stroke-width=".5"
                stroke-linecap="round"
              />
            </g>

            <g transform="translate(200, 20)">
              <circle cx="0" cy="0" r="2" fill="white" />
              <path
                d="M0,-10 L0,10 M-10,0 L10,0"
                stroke="white"
                stroke-width=".5"
                stroke-linecap="round"
              />
            </g>

            <g transform="translate(230, 130)">
              <circle cx="0" cy="0" r="2" fill="white" />
              <path
                d="M0,-10 L0,10 M-10,0 L10,0"
                stroke="white"
                stroke-width=".5"
                stroke-linecap="round"
              />
            </g>

            <g transform="translate(300, 60)">
              <circle cx="0" cy="0" r="2" fill="white" />
              <path
                d="M0,-6 L0,6 M-6,0 L6,0"
                stroke="white"
                stroke-width="0.5"
                stroke-linecap="round"
              />
            </g>

            <g transform="translate(400, 180)">
              <circle cx="0" cy="0" r="1.5" fill="white" />
              <path
                d="M0,-4 L0,4 M-4,0 L4,0"
                stroke="white"
                stroke-width="0.5"
                stroke-linecap="round"
              />
            </g>

            <g transform="translate(500, 100)">
              <circle cx="0" cy="0" r="1" fill="white" />
              <path
                d="M0,-3 L0,3 M-3,0 L3,0"
                stroke="white"
                stroke-width="0.5"
                stroke-linecap="round"
              />
            </g>

            <g transform="translate(600, 50)">
              <circle cx="0" cy="0" r="1.8" fill="white" />
              <path
                d="M0,-5 L0,5 M-5,0 L5,0"
                stroke="white"
                stroke-width="0.5"
                stroke-linecap="round"
              />
            </g>

            <g transform="translate(700, 90)">
              <circle cx="0" cy="0" r="1.2" fill="white" />
              <path
                d="M0,-3.5 L0,3.5 M-3.5,0 L3.5,0"
                stroke="white"
                stroke-width="0.5"
                stroke-linecap="round"
              />
            </g>

            <g transform="translate(700, 30)">
              <circle cx="0" cy="0" r="2" fill="white" />
              <path
                d="M0,-10 L0,10 M-10,0 L10,0"
                stroke="white"
                stroke-width=".5"
                stroke-linecap="round"
              />
            </g>

            <g transform="translate(840, 50)">
              <circle cx="0" cy="0" r="1.5" fill="white" />
              <path
                d="M0,-4.5 L0,4.5 M-4.5,0 L4.5,0"
                stroke="white"
                stroke-width="0.5"
                stroke-linecap="round"
              />
            </g>

            <g transform="translate(780, 130)">
              <circle cx="0" cy="0" r="1" fill="white" />
              <path
                d="M0,-3 L0,3 M-3,0 L3,0"
                stroke="white"
                stroke-width="0.5"
                stroke-linecap="round"
              />
            </g>

            <g transform="translate(600, 150)">
              <circle cx="0" cy="0" r="1.8" fill="white" />
              <path
                d="M0,-5 L0,5 M-5,0 L5,0"
                stroke="white"
                stroke-width="0.5"
                stroke-linecap="round"
              />
            </g>

            <g transform="translate(1000, 30)">
              <circle cx="0" cy="0" r="1.8" fill="white" />
              <path
                d="M0,-5 L0,5 M-5,0 L5,0"
                stroke="white"
                stroke-width="0.5"
                stroke-linecap="round"
              />
            </g>
            <g transform="translate(1100, 50)">
              <circle cx="0" cy="0" r="1.8" fill="white" />
              <path
                d="M0,-5 L0,5 M-5,0 L5,0"
                stroke="white"
                stroke-width="0.5"
                stroke-linecap="round"
              />
            </g>
            <g transform="translate(1200, 20)">
              <circle cx="0" cy="0" r="1.8" fill="white" />
              <path
                d="M0,-5 L0,5 M-5,0 L5,0"
                stroke="white"
                stroke-width="0.5"
                stroke-linecap="round"
              />
            </g>
            <g transform="translate(1300, 10)">
              <circle cx="0" cy="0" r="1.8" fill="white" />
              <path
                d="M0,-5 L0,5 M-5,0 L5,0"
                stroke="white"
                stroke-width="0.5"
                stroke-linecap="round"
              />
            </g>
          </svg>
        </div>
      </div>
    </>
  )
}

export default WaveBackground
